<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="false"
    ></loading> 
    <b-form-checkbox  
      name="check-button"
      :checked="data.item.replica" 
      disabled
      switch
    >
      <b></b>
    </b-form-checkbox>
    
  </div>
</template>

<script>
export default {
  name: "CheckReplicaComponente",
  props: {
    data: Object,
    resource: Object,
  },
  data: () => ({
    loading : false,
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {

  },
};
</script>
